<template>
  <VueRecaptcha
    v-if="siteKey.length > 0 && !isLoading"
    :load-recaptcha-script="true"
    :sitekey="siteKey"
    @verify="$emit('verify', true)"
    @expired="$emit('verify', false)"
  />
  <div v-else>
    Loading...
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha"
import getSecret from '@/services/get-secret.service'

export default {
  name: 'Recaptcha',

  data() {
    return {
      siteKey: '',
      isLoading: true
    }
  },

  mounted() {
    getSecret('recaptcha').then(({ key }) => {
      this.siteKey = key
      this.isLoading = false
    })
  },

  components: {
    VueRecaptcha
  }
}
</script>
